import React from 'react'

import { useStoreActions, useStoreState } from 'store'

const types: ('Purchase' | 'Refinance')[] = ['Purchase', 'Refinance']

export default function MortgageType(
  props: JSX.IntrinsicAttributes & { className?: string; smallButtons?: string; idLocation?: string }
) {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)
  const { mortgageType } = useStoreState(state => state.dimensions.dimensions)

  const handleChange = (type: 'Purchase' | 'Refinance') => {
    updateDimensions({ mortgageType: type })
    onInputTracking({ name: 'mortgagetype', type: 'PRODUCTTYPE', label: 'mortgage type', value: type })
  }

  return (
    <div className={`form-element-container sm:mb-2 md:mb-0 ${props.className}`}>
      <label className="FormLabel display-none md:display-block">Mortgage type</label>
      <div className={`FormButtonGroup FormButtonGroup--fill ${props.smallButtons} md:mb-0`}>
        {types.map((type: 'Purchase' | 'Refinance') => (
          <span key={type} className="FormButtonGroup-button">
            <input
              className="FormButtonGroup-input"
              type="checkbox"
              id={`checkbox-${type}${props.idLocation || ''}`}
              checked={mortgageType === type}
              onChange={() => handleChange(type)}
            />
            <label
              data-testid={`mortgageType-${type}`}
              className="type-body-two FormButtonGroup-label"
              htmlFor={`checkbox-${type}${props.idLocation || ''}`}
            >
              {type}
            </label>
          </span>
        ))}
      </div>
    </div>
  )
}
